import React, {Component} from 'react';

import swal from 'sweetalert2';
import axios from "axios/index";

import urls from "../../../../utils/urls";
import {tokenHeader} from "../../../../utils/headers";
import {ajaxHandler} from "../../../../utils/errors";

export default class TerminalDelete extends Component {

    constructor(props) {
        super(props);
        this.state = {
            ajaxInProgress: false
        };
    }

    _submitForm = () => {

        this.setState({ajaxInProgress: true});

        let data = {
            active: false,
            name: this.props.item.name,
            code: this.props.item.code
        };

        const DELETE_TERMINAL = `${urls.API_ROOT}/api/v1/terminal/id/${this.props.item.id}/`;
        axios.put(`${DELETE_TERMINAL}`, data, tokenHeader())
            .then(this._onSubmitSuccess)
            .catch(ajaxHandler);
    };

    _onSubmitSuccess = () => {
        this.setState({ajaxInProgress: false});

        swal({
            title: `Depósito desactivado`,
            html: 'El depósito ha sido desactivado correctamente',
            type: 'success',
            showConfirmButton: false,
            timer: 2000
        });

        this.props.closeAction();
        this.props.refreshAction();
    };

    render() {
        return (
            <div className={"admin-modal"}>
                <div className={"row"}>
                    <h3 className={"center"}>Eliminar Depósito</h3>
                </div>
                <div className={"row"}>
                    <div className={"col s12 input-field"}>
                        <p>
                            Usted esta por desactivar al depósito <b>{this.props.item.name}</b>.
                            Esta acción no puede deshacerse. ¿Desea continuar?
                        </p>
                    </div>
                </div>
                <div className={"row"}>
                    <div className={"col s12 center"}>
                        <button
                            className={`btn btn-shell-empty z-depth-0 ${this.state.ajaxInProgress ? 'disabled' : ''}`}
                            onClick={this.props.closeAction}
                        >Cancelar</button>
                        <button
                            className={`btn btn-shell z-depth-0 ${this.state.ajaxInProgress ? 'disabled' : ''}`}
                            onClick={this._submitForm}
                        >Continuar</button>
                    </div>
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/containers/Dashboard/Admin/Modals/TerminalDelete.js